module.exports = __webpack_public_path__ + "static/media/yellowtail-kingfish.541f1ec1.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/fish/yellowtail-kingfish.png
// module id = 342
// module chunks = 0